/* Universal Basic — seamless crossfade loop for the NoFootprint sun video.
   The NASA clip isn't a seamless loop, so a hard loop flickers/jumps. This crossfades
   between two copies across the seam. Falls back to native loop if anything goes wrong. */
(function () {
  'use strict';
  var FADE = 0.8; // crossfade seconds

  function init(wrap) {
    var a = wrap.querySelector('.ub-sunvid--a');
    var b = wrap.querySelector('.ub-sunvid--b');
    if (!a || !b) { if (a) { a.loop = true; safePlay(a); } return; }

    // Mobile (esp. iOS) limits simultaneous video playback and dual download is wasteful:
    // use a single native-looping video, drop the second one entirely.
    var smallScreen = window.matchMedia && window.matchMedia('(max-width: 760px)').matches;
    if (smallScreen) {
      a.muted = true; a.playsInline = true; a.loop = true; a.style.opacity = '1';
      try { b.pause(); b.removeAttribute('preload'); b.innerHTML = ''; b.parentNode && b.parentNode.removeChild(b); } catch (e) {}
      var p = a.play(); if (p && p.catch) p.catch(function () {});
      return;
    }

    [a, b].forEach(function (v) {
      v.muted = true; v.loop = false; v.playsInline = true;
      v.style.transition = 'opacity ' + FADE + 's linear';
    });
    a.style.opacity = '1'; b.style.opacity = '0';

    var active = a, idle = b, swapping = false;

    function ready(v) { return v.readyState >= 1 && !isNaN(v.duration) && v.duration > 0; }
    function safePlayLocal(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }

    function onTime() {
      if (swapping || !ready(active)) return;
      if (active.duration - active.currentTime <= FADE) {
        swapping = true;
        var incoming = idle, outgoing = active;
        try { incoming.currentTime = 0; } catch (e) {}
        safePlayLocal(incoming);
        incoming.style.opacity = '1';
        outgoing.style.opacity = '0';
        setTimeout(function () {
          outgoing.pause();
          try { outgoing.currentTime = 0; } catch (e) {}
          active = incoming; idle = outgoing; swapping = false;
        }, FADE * 1000);
      }
    }

    a.addEventListener('timeupdate', onTime);
    b.addEventListener('timeupdate', onTime);
    // safety net: if a video ends before the crossfade caught it, restart cleanly
    a.addEventListener('ended', function () { if (!swapping) { try { a.currentTime = 0; } catch (e) {} safePlayLocal(a); } });
    b.addEventListener('ended', function () { if (!swapping) { try { b.currentTime = 0; } catch (e) {} safePlayLocal(b); } });

    function start() { try { active.currentTime = 0; } catch (e) {} safePlayLocal(active); }
    if (ready(active)) start(); else active.addEventListener('loadedmetadata', start, { once: true });
    active.addEventListener('canplay', function () { if (active.paused) safePlayLocal(active); }, { once: true });

    function safePlay(v) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
  }

  function boot() {
    var wraps = document.querySelectorAll('.ub-sunwrap');
    for (var i = 0; i < wraps.length; i++) {
      try { init(wraps[i]); } catch (e) { /* native loop fallback already set on markup */ }
    }
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
